export default "__VITE_ASSET__c48e2b65__"